var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.status)?_c(_setup.AppChip,{attrs:{"color":_setup.status.color,"text-color":"white--text","small":""}},[_vm._v("\n  "+_vm._s(_setup.status.text))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }